interface UsePageOrderingParams {
  numPages: number;
  pageGroups: number[][];
  removedPages: number[];
}

export const usePageOrdering = ({
  numPages,
  pageGroups,
  removedPages,
}: UsePageOrderingParams): number[] => {
  // Create ordered array of pages based on groups
  const orderedPages: number[] = [];
  const hasMultiPageGroups = pageGroups.some((group) => group.length > 1);

  if (hasMultiPageGroups) {
    // Show pages in group order (custom order for merged groups)
    pageGroups.forEach((group) => {
      if (group.length > 1) {
        // Multi-page group: maintain custom order
        orderedPages.push(...group);
      } else {
        // Single page: will be sorted with other singles later
        orderedPages.push(...group);
      }
    });

    const multiPageGroupPages: number[] = [];
    const singlePages: number[] = [];

    pageGroups.forEach((group) => {
      if (group.length > 1) {
        multiPageGroupPages.push(...group);
      } else {
        singlePages.push(...group);
      }
    });

    singlePages.sort((a, b) => a - b);
    orderedPages.length = 0;

    let singleIndex = 0;
    pageGroups.forEach((group) => {
      if (group.length > 1) {
        orderedPages.push(...group);
      } else {
        orderedPages.push(singlePages[singleIndex++]);
      }
    });
  } else {
    // No merged groups, show all pages in numerical order
    orderedPages.push(
      ...Array.from({ length: numPages }, (_, i) => i + 1).sort((a, b) => a - b)
    );
  }

  return orderedPages.filter(
    (pageNumber) => !removedPages.includes(pageNumber)
  );
};
